// LUMINA · components/EnergyRingChart.jsx
// Phase 58: SVG ring progress chart, Apple Watch style
// Color auto-derived from score (80+ green, 60-79 gold, 40-59 brown, <40 grey)
// — consistent with EnergyForecastPanel bar chart legend

import React from 'react';

const ELEMENT_COLORS = {
  forest:  { track: "#2d6a4f", glow: "rgba(45,106,79,0.3)",  bg: "rgba(45,106,79,0.08)"  },
  crimson: { track: "#9b2335", glow: "rgba(155,35,53,0.3)",  bg: "rgba(155,35,53,0.08)"  },
  gold:    { track: "#8B6914", glow: "rgba(139,105,20,0.35)", bg: "rgba(212,175,55,0.08)" },
  steel:   { track: "#4a5568", glow: "rgba(74,85,104,0.3)",  bg: "rgba(74,85,104,0.08)"  },
  indigo:  { track: "#2d3a8c", glow: "rgba(45,58,140,0.3)",  bg: "rgba(45,58,140,0.08)"  },
};

function scoreColors(s) {
  if (s >= 80) return { track: "#064E3B", glow: "rgba(6,78,59,0.25)" };
  if (s >= 60) return { track: "#D4AF37", glow: "rgba(212,175,55,0.30)" };
  if (s >= 40) return { track: "#8B6914", glow: "rgba(139,105,20,0.25)" };
  return          { track: "#9CA3AF", glow: "rgba(156,163,175,0.20)" };
}

export default function EnergyRingChart({ score = 50, theme, size = 120, strokeWidth = 10 }) {
  // Auto-derive color from score; explicit theme overrides
  const colors = theme ? (ELEMENT_COLORS[theme] || ELEMENT_COLORS.gold) : scoreColors(score);
  const r = (size - strokeWidth * 2) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;
  const pct = Math.min(100, Math.max(0, score)) / 100;
  const dashOffset = circumference * (1 - pct);

  return (
    <div style={{ position: "relative", width: size, height: size, display: "inline-flex",
      alignItems: "center", justifyContent: "center" }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        {/* Track */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke="rgba(0,0,0,0.08)"
          strokeWidth={strokeWidth}
        />
        {/* Progress */}
        <circle
          cx={cx} cy={cy} r={r}
          fill="none"
          stroke={colors.track}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          style={{ filter: `drop-shadow(0 0 6px ${colors.glow})`, transition: "stroke-dashoffset 0.8s ease" }}
        />
      </svg>
      {/* Center label */}
      <div style={{
        position: "absolute", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
      }}>
        <span style={{ fontSize: size * 0.22, fontWeight: 700, color: colors.track,
          fontFamily: "'Inter',sans-serif", lineHeight: 1 }}>{score}</span>
        <span style={{ fontSize: size * 0.09, color: "rgba(0,0,0,0.4)", letterSpacing: 1,
          fontFamily: "'Inter',sans-serif" }}>分</span>
      </div>
    </div>
  );
}
